module.exports = __webpack_public_path__ + "static/cocina-e3a0c9541e164c04784313d8cf946428.jpg";